







import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';

export default Vue.extend({
  name: 'NemipayForm',
  components: {
    ValidationObserver,
  },
  methods: {
    async submit() {
      this.$emit('submit', true);
    },
  },
});
